import { LayoutPrincipal } from '@/components/layout';
import { ListaContadoDetallePantalla } from '@/pages/ListaContadoDetallePantalla';
import { NoEncontradoPantalla } from '@/pages/NoEncontradoPantalla';
import { PropuestaPagoDetallePantalla } from '@/pages/PropuestaPagoDetallePantalla';
import { PropuestaPagoNuevaPantalla } from '@/pages/PropuestaPagoNuevaPantalla';
import { PropuestasPagoLayout } from '@/pages/PropuestasPagoLayout';
import { PropuestasPagoPantalla } from '@/pages/PropuestasPagoPantalla';
import { SolicitudesContadoPantalla } from '@/pages/SolicitudesContadoPantalla';
import { VencimientosPantalla } from '@/pages/VencimientosPantalla';
import { CategoriasPantalla } from '@/pages/flujo-semanal/CategoriasPantalla';
import { ConceptosPantalla } from '@/pages/flujo-semanal/ConceptosPantalla';
import { DebugPantalla } from '@/pages/flujo-semanal/DebugPantalla';
import { DetalleCategoriaPantalla } from '@/pages/flujo-semanal/DetalleCategoriaPantalla';
import { HistorialPantalla } from '@/pages/flujo-semanal/HistorialPantalla';
import { ObligacionesPantalla } from '@/pages/flujo-semanal/ObligacionesPantalla';
import { ProveedoresCreditoPantalla } from '@/pages/flujo-semanal/ProveedoresCreditoPantalla';
import { ProveedoresPactadosPantalla } from '@/pages/flujo-semanal/ProveedoresPactadosPantalla';
import { ProveedoresPantalla } from '@/pages/flujo-semanal/ProveedoresPantalla';
import { ProyeccionPantalla } from '@/pages/flujo-semanal/ProyeccionPantalla';
import { SemanaActualPantalla } from '@/pages/flujo-semanal/SemanaActualPantalla';
import { VincularProveedoresPantalla } from '@/pages/flujo-semanal/VincularProveedoresPantalla';
import { Navigate, createBrowserRouter } from 'react-router-dom';

export const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <LayoutPrincipal />,
      children: [
        { index: true, element: <Navigate to="/vencimientos" replace /> },
        {
          path: 'vencimientos',
          children: [
            { index: true, element: <VencimientosPantalla /> },
            { path: 'solicitudes', element: <SolicitudesContadoPantalla /> },
            { path: 'listas-contado/:id', element: <ListaContadoDetallePantalla /> },
            {
              path: 'propuestas',
              element: <PropuestasPagoLayout />,
              children: [
                { index: true, element: <PropuestasPagoPantalla /> },
                { path: 'nueva', element: <PropuestaPagoNuevaPantalla /> },
                { path: ':id', element: <PropuestaPagoDetallePantalla /> },
              ],
            },
          ],
        },
        {
          path: 'flujo-semanal',
          children: [
            { index: true, element: <SemanaActualPantalla /> },
            { path: 'historial', element: <HistorialPantalla /> },
            { path: 'proyeccion', element: <ProyeccionPantalla /> },
            { path: 'proveedores', element: <ProveedoresPantalla /> },
            { path: 'detalle/:categoriaId', element: <DetalleCategoriaPantalla /> },
            { path: 'proveedores-credito', element: <ProveedoresCreditoPantalla /> },
            { path: 'conceptos', element: <ConceptosPantalla /> },
            { path: 'categorias', element: <CategoriasPantalla /> },
            { path: 'obligaciones', element: <ObligacionesPantalla /> },
            { path: 'proveedores-pactados', element: <ProveedoresPactadosPantalla /> },
            { path: 'vincular-proveedores', element: <VincularProveedoresPantalla /> },
            { path: 'debug', element: <DebugPantalla /> },
          ],
        },
        { path: '*', element: <NoEncontradoPantalla /> },
      ],
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
    },
  },
);
